import React from 'react'
import styled from 'styled-components'
import { useTheme } from '@mui/material/styles'
import EventRepeatIcon from '@mui/icons-material/EventRepeat'
import { TIME_IN_US_FORMAT } from '@/v2/constants'
import Typography from '@/v2/components/common/Typography'
import { safeFormat } from '@/v2/utils/convert'

const Item = styled.div`
  display: flex;
  align-items: center;
  padding: 14px 26px;
  margin-top: 15px;
  border-radius: 3px;
  border: 1px dashed ${({ theme }) => theme.silver.dark};
  background: transparent;
`
const DateTime = styled.div`
  align-self: baseline;
  margin-right: 56px;
  min-width: 114px;
`
const Title = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  gap: 8px;
`

const MOVED_FORMAT = 'MMM dd, yyyy · h:mm a'

const RescheduleEvent = ({ event }) => {
  const theme = useTheme()
  const {
    rescheduledAt,
    appointment,
    user,
    byPatient,
    fromStartsAt,
    toStartsAt,
  } = event
  // A self reschedule has no user, and calling that "system" hides who acted.
  const author = byPatient ? 'the patient' : user?.fullName || 'system'
  const appointmentTitle = appointment?.appointmentType?.title || 'Appointment'
  // Null on a staff flag audit, which carries no starts_at at all.
  const movedBetween =
    fromStartsAt && toStartsAt
      ? `${safeFormat(fromStartsAt, MOVED_FORMAT)} → ${safeFormat(
          toStartsAt,
          MOVED_FORMAT
        )}`
      : null

  return (
    <Item theme={theme.palette}>
      <DateTime>
        <Typography bold fontSize="12px" sx={{ mb: '2px' }}>
          {safeFormat(rescheduledAt, 'MMMM dd, yyyy')}
        </Typography>
        <Typography uppercase fontSize="12px">
          {safeFormat(rescheduledAt, TIME_IN_US_FORMAT)}
        </Typography>
      </DateTime>
      <Title>
        <EventRepeatIcon fontSize="small" sx={{ color: 'text.secondary' }} />
        <div>
          <Typography italic fontSize="14px" sx={{ mb: '2px' }}>
            {`Rescheduled — ${appointmentTitle}`}
          </Typography>
          <Typography fontSize="12px" sx={{ color: 'text.secondary' }}>
            {`by ${author}`}
          </Typography>
          {movedBetween && (
            <Typography fontSize="12px" sx={{ color: 'text.secondary' }}>
              {movedBetween}
            </Typography>
          )}
        </div>
      </Title>
    </Item>
  )
}

export default RescheduleEvent
